import { render, staticRenderFns } from "./ItemSmallDisplay.vue?vue&type=template&id=3a53aa21"
import script from "./ItemSmallDisplay.vue?vue&type=script&lang=js"
export * from "./ItemSmallDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports